<div class="user-button-container" #userButton (vrClickOutside)="onClickOutside()" fxLayout="row"
  fxLayoutAlign="space-between center">

  <!-- Subscription expired: show only logout power button -->
  <ng-container *ngIf="hideMenu">
    <button mat-icon-button matTooltip="Logout" style="margin-left: auto" (click)="signOut()">
      <mat-icon>power_settings_new</mat-icon>
    </button>
  </ng-container>

  <ng-container *ngIf="!hideMenu">

    <!-- <div fxHide fxShow.gt-md>
    <button [attr.guide]="'user-btn-1' + '__' + sanitizeUrl(url)" color="primary" mat-icon-button (click)="toggleFullscreen()" class="icon-button">
      <mat-icon>fullscreen</mat-icon>
    </button>
  </div> -->


    <div *ngIf="read">
      <button style="margin-right: 8px;" [attr.guide]="'user-btn-2' + '__' + sanitizeUrl(url)" mat-icon-button
        [matMenuTriggerFor]="notificationMenu" #userNotificationTrigger="matMenuTrigger" class="icon-button">
        <mat-icon>notifications</mat-icon>
        <span *ngIf="unreadCount > 0" class="notification-badge">{{ unreadCount }}</span>
      </button>

      <mat-menu #notificationMenu="matMenu" class="notification-panel">
        <div class="panel-header">
          <h3>Notifications</h3>
          <!-- <button mat-icon-button aria-label="notification-options">
          <mat-icon>more_vert</mat-icon>
        </button> -->
        </div>

        <div class="panel-tabs" (click)="$event.stopPropagation()">
          <button class="tab" [class.active]="selectedTab === 'all'"
            (click)="$event.stopPropagation(); setTab('all')">All</button>
          <button class="tab" [class.active]="selectedTab === 'system'"
            (click)="$event.stopPropagation(); setTab('system')">System</button>
          <!-- <button class="tab" [class.active]="selectedTab === 'archive'"
            (click)="$event.stopPropagation(); setTab('archive')">Archive</button> -->
        </div>

        <div class="panel-content" (scroll)="onNotificationsScroll($event)">
          <ng-container *ngIf="notificationList?.length; else emptyNotifications">
            <ng-container *ngFor="let notification of notificationList">
              <div *ngIf="(selectedTab === 'all') ||
                        (selectedTab === 'system' && notification.type === 'System') ||
                        (selectedTab === 'archive' && (notification.archived || notification.isArchived))"
                class="notification-item" [class.unread]="notification.isRead === 0">

                <div class="notification-content" (click)="$event.stopPropagation(); openNotification(notification)">
                  <div class="notification-type">{{ notification.type }}</div>
                  <div class="notification-message">{{ notification.message }}</div>
                  <div class="notification-time">{{ notification.createdAt | date:'MMM dd, h:mm a' }}</div>
                </div>

                <div class="notification-actions">
                  <button mat-icon-button [matMenuTriggerFor]="itemMenu" (click)="$event.stopPropagation()">

                    <mat-icon>more_vert</mat-icon>
                  </button>
                </div>

                <mat-menu #itemMenu="matMenu" class="notification-action-menu">

                  <!-- MARK AS READ -->
                  <button mat-menu-item  (click)="toggleRead(notification)">

                    <mat-icon>done_all</mat-icon>

                    <span>Mark as read</span>
                  </button>

                  <!-- DELETE -->
                  <!-- <button mat-menu-item (click)="deleteNotification(notification)">

                    <mat-icon>delete_outline</mat-icon>

                    <span>Delete</span>
                  </button> -->

                </mat-menu>

              </div>
            </ng-container>
          </ng-container>

          <ng-template #emptyNotifications>
            <div class="empty-state">
              <mat-icon class="empty-icon">notifications_none</mat-icon>
              <h4>No notifications</h4>
              <p>When you have notifications, they will appear here.</p>
            </div>
          </ng-template>
        </div>

        <!-- <div class="padding-10">
        <button [attr.guide]="'user-btn-4' + '__' + sanitizeUrl(url)" mat-button (click)="gotogrid()" class="view-more">
          View More <mat-icon>done_all</mat-icon>
        </button>
      </div> -->

        <!-- <mat-menu #itemMenu="matMenu" >
        <button mat-menu-item (click)="toggleRead(notification)">
          <mat-icon>done</mat-icon>
          <span>Mark as read</span>
        </button>
        <button mat-menu-item (click)="gotogrid()">
          <mat-icon>open_in_new</mat-icon>
          <span>Open</span>
        </button>
      </mat-menu> -->

      </mat-menu>
    </div>

    <!-- <div fxHide fxShow.gt-md *ngIf="posEnabled == 1">
    <button [attr.guide]="'user-btn-5' + '__' + sanitizeUrl(url)" mat-icon-button [matMenuTriggerFor]="alertsMenu" class="pos-button12">
      <mat-icon class="warning-icon">warning</mat-icon>
    </button>
  </div> -->

    <mat-menu #alertsMenu="matMenu">
      <button [attr.guide]="'user-btn-6' + '__' + sanitizeUrl(url)" mat-menu-item (click)="handleQuantityAlert()">
        <mat-icon>inventory_2</mat-icon>
        <span>Quantity Alerts</span>
      </button>
      <button [attr.guide]="'user-btn-7' + '__' + sanitizeUrl(url)" mat-menu-item (click)="handleExpiryAlert()">
        <mat-icon>schedule</mat-icon>
        <span>Expiry Alerts</span>
      </button>
    </mat-menu>


    <div *ngIf="dialerType == 7" fxHide fxShow.gt-md>
      <button [attr.guide]="'user-btn-8' + '__' + sanitizeUrl(url)" (click)="navigateto()" mat-raised-button
        class="pos-button">
        <mat-icon> call</mat-icon>
      </button>
    </div>


    <div fxHide fxShow.gt-md *ngIf="posEnabled == 1">
      <button [attr.guide]="'user-btn-9' + '__' + sanitizeUrl(url)" (click)="gotoPos()" mat-raised-button
        class="pos-button">
        Pos
      </button>
    </div>
    <button [attr.guide]="'user-btn-13' + '__' + sanitizeUrl(url)" *ngIf="!opened" color="primary" class="user-button"
      mat-button [matMenuTriggerFor]="menu" class="icon-button">
      <mat-icon> account_circle</mat-icon> <span fxHide.lt-md color="primary">{{username}}</span>
    </button>

    <!-- Mat Menu -->
    <mat-menu #menu="matMenu" class="custom-menu">
      <div class="custom-menu-panel">
        <button [attr.guide]="'user-btn-14' + '__' + sanitizeUrl(url)" mat-menu-item (click)="profile()">
          <mat-icon>account_circle</mat-icon>
          <span>Profile</span>
        </button>

        <button [attr.guide]="'user-btn-two-factor' + '__' + sanitizeUrl(url)" mat-menu-item
          (click)="openTwoFactorAuth()">
          <mat-icon>verified_user</mat-icon>
          <span>{{ twoFactorEnabled ? 'Two Factor Authentication' : 'Enable Authentication' }}</span>
        </button>

        <button [attr.guide]="'user-btn-billing' + '__' + sanitizeUrl(url)" mat-menu-item (click)="billing()">
          <mat-icon>receipt_long</mat-icon>
          <span>Billing</span>
        </button>

        <button [attr.guide]="'user-btn-tour' + '__' + sanitizeUrl(url)" mat-menu-item (click)="startTour()">
          <mat-icon>tour</mat-icon>
          <span>Tour</span>
        </button>

        <button [attr.guide]="'user-btn-15' + '__' + sanitizeUrl(url)" *ngIf="rfId" mat-menu-item
          (click)="copyInputUrl()">
          <mat-icon> content_copy</mat-icon>
          <span>Copy Referral Code</span>
        </button>

        <button [attr.guide]="'user-btn-16' + '__' + sanitizeUrl(url)" mat-menu-item (click)="signOut()">
          <mat-icon>logout</mat-icon>
          <span>Logout</span>
        </button>


      </div>
    </mat-menu>

  </ng-container><!-- end *ngIf="!hideMenu" -->

</div>